import React, { useCallback, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useDispatch } from 'react-redux';
import Logo from '../Logo/Logo';
import { stopImpersonatingUser } from '../../actions/impersonation';
import useSeasonSettings from '../../selectors/useSeasonSettings';
import BuyplanNavigation from '../Navigation/BuyplanNavigation';
import useUserProfile from '../../selectors/useUserProfile';
import { deactivateUserImpersonation } from '../../services/impersonationService';
import useImpersonationStatus from '../../selectors/useImpersonationStatus';
import Button from '../Button/Button';
import ChannelSeasonSelection from './ChannelSeasonSelection';
import './Header.scss';

function Header() {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const profile = useUserProfile();
    const isHome = matchPath(pathname, { path: '/', exact: true }) !== null;
    const { isHistoricalSeason } = useSeasonSettings();
    const { impersonatedProfile, impersonationInProgress } = useImpersonationStatus();
    const [hasError, setHasError] = useState(false);

    const handleStopImpersonation = useCallback(async () => {
        if (hasError) setHasError(false);
        try {
            await deactivateUserImpersonation(false);
            dispatch(stopImpersonatingUser());
            window.location.reload();
        } catch (err: unknown) {
            // handled by global error
        }
    }, [dispatch, hasError]);

    if (!profile || isHome) {
        return null;
    }

    const isProduction = window.location.hostname === 'buyplan.dsmplanning.nikecloud.com';

    return (
        <header className={cn('header', { 'header__historical-season': isHistoricalSeason })}>
            {!isProduction && (
                <div className="header__environment__warning">
                    <FontAwesomeIcon icon={faAsterisk as IconProp} title="Test Environment" /> TEST ENVIRONMENT
                </div>
            )}
            {impersonationInProgress && (
                <div className="header__impersonation__warning">
                    <span>{`IMPERSONATION IS ACTIVE FOR USER: ${impersonatedProfile?.email}`}</span>
                    <Button size="s" onClick={() => dispatch(handleStopImpersonation())}>
                        Stop Impersonation
                    </Button>
                </div>
            )}
            <div className="header__container">
                <div className="header__logo">
                    <Logo app="buyplan" hideNameOnSmallScreen />
                    <div className="header__dropdown">
                        <ChannelSeasonSelection />
                    </div>
                </div>
                <div className={cn('header__navigation header__navigation--margin-align')}>
                    <BuyplanNavigation />
                </div>

                <div className="header__spacer" />
            </div>
        </header>
    );
}

export default Header;
